import { useCallback, useEffect, useState } from 'react';
import { useSelector } from '../../../../store/hooks';
import { customerUpdatesState } from '../../../../store/features/customerUpdates/customerUpdatesSlice';

export type CustomerUpdatesDialogView =
    | 'initial'
    | 'unableToNotify'
    | 'messageFeedback';

export const useCustomerUpdatesDialogSubformState = (
    view: CustomerUpdatesDialogView,
    onMessageFeedback?: (message: string) => void
) => {
    const unableToNotifyReasons =
        useSelector(customerUpdatesState).unableToNotifyReasons.data;

    const [selectedUnableToNotifyReason, setSelectedUnableToNotifyReason] =
        useState<string | undefined>(undefined);
    const [feedbackMessage, setFeedbackMessage] = useState('');

    const resetSubforms = useCallback(() => {
        setSelectedUnableToNotifyReason(undefined);
        setFeedbackMessage('');
    }, []);

    const disableUnableToNotifyButton =
        !!unableToNotifyReasons.length && !selectedUnableToNotifyReason;

    const disableFeedbackButton = !onMessageFeedback || !feedbackMessage;

    const onFeedbackSubmitCallback = useCallback(() => {
        if (!onMessageFeedback || !feedbackMessage) {
            return;
        }

        onMessageFeedback(feedbackMessage);
    }, [feedbackMessage, onMessageFeedback]);

    useEffect(() => {
        resetSubforms();
    }, [view, resetSubforms]);

    return {
        unableToNotifyReasons,
        selectedUnableToNotifyReason,
        setSelectedUnableToNotifyReason,
        feedbackMessage,
        setFeedbackMessage,
        disableUnableToNotifyButton,
        disableFeedbackButton,
        onFeedbackSubmitCallback,
        resetSubforms,
    };
};
